<div class="mainContent">
  <div class="pageHeader">Logs</div>
  <div class="selectionHeader">
    <mat-form-field class="my-form-field selectionPanel">
      <mat-label i18n>Log files</mat-label>
      <mat-select [(value)]="selectLog" (selectionChange)="selectedLog()" disableOptionCentering>
        <mat-option *ngFor="let s of logFiles" [value]="s">{{s}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [checked]="cacheLogs" (click)="$event.stopPropagation()" (change)="loadCacheLogs($event)" class="cacheCheckbox">CacheLogs</mat-checkbox>
    <div class="buttonContent">
      <a [href]="fileUrl" *ngIf="fileUrl" download="{{selectLog}}" matTooltip="download">
        <button mat-raised-button type="button" color="primary">DOWNLOAD</button>
      </a>
    </div>
  </div>

  <div class="logDetails">
    <div *ngFor="let log of logContent">
      {{log}}
    </div>
  </div>
</div>
